import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonfilterService } from './commonfilter.service';
import { Observable } from 'rxjs';


const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});
@Injectable({
  providedIn: 'root'
})
export class CorporateService {
 


  corporateUrl = '/superadmin/rest/mgmt/corporate';
  corporateLicenseRenewalUrl = '/superadmin/rest/mgmt/corporate/license/renewal';
  revertUrl = '/superadmin/rest/mgmt/corporate/license';
  addressUrl = '/superadmin/rest/mgmt/account/license';
  corporateBranchVerifyLevelUrl = '/superadmin/rest/mgmt/corporate/branch/verification';
  sectors: any;

    public JDN = {'JDN': {
    'JDNType': 'Percent',
    'JDNPercent': [{
        'percentage': 5,
        'maxDiscount': 100
    }, {
        'percentage': 10,
        'maxDiscount': 200
    }, {
        'percentage': 20,
        'maxDiscount': 300
    }]
}
  };
//   public JDN = { 'JDN': {
//     'JDNType': 'Label',
//     'JDNLabel': '50% discount'
// }};
  constructor(private http: HttpClient, private commonService: CommonfilterService) {
    this.commonService.getServiceSectors()
    .subscribe(res => {
      this.sectors = res;
    });
   }


getCorporates( filter, sortOrder,
pageNumber, pageSize = 10): Observable<any> {
  return this.http.get(this.corporateUrl + '?' + filter, {
      params: new HttpParams()
      .set('asc', sortOrder)
          .set('from', pageNumber.toString())
          .set('count', pageSize.toString())
  });
}
getTotalFilterCount(filter: any): any {
  return this.http.get(this.corporateUrl + '/count?' + filter, { headers: headers });
}
createCorporate(data) {
  return this.http.post(this.corporateUrl, data , {headers: headers});
}
getDetails(id) {
  return this.http.get(this.corporateUrl + '/' + id,  {headers: headers} );
}
updateCorporate(data) {
  return this.http.put(this.corporateUrl, data , {headers: headers});
}
deleteCorporate(data) {
  return this.http.delete(this.corporateUrl + '/' + data, { headers: headers});

}
updateBranchVerifyLevel(corpId) {
  return this.http.put(this.corporateBranchVerifyLevelUrl + '/' + corpId , {  headers : headers});
}
getLicenseDetails(corpId) {
  return this.http.get(this.corporateUrl + '/' + corpId  + '/license',  {headers: headers} );
}
getDomainName(sectorId) {

  let sectorName = '';
  for (let i = 0; i < this.sectors.length; i++) {
    // tslint:disable-next-line:triple-equals
    if (sectorId == this.sectors[i].id) {
      sectorName = this.sectors[i].displayName;
      break;
    }
  }

  return sectorName;
}
getSubDomainName(sectorId, subSectorId) {

  let subSectorName = '';
  console.log(JSON.stringify(this.sectors));
  for (let i = 0; i < this.sectors.length; i++) {
    // tslint:disable-next-line:triple-equals
    if (sectorId == this.sectors[i].id) {
      for (let j = 0; j < this.sectors[i].subDomains.length; j++) {
        // tslint:disable-next-line:triple-equals
        if (this.sectors[i].subDomains[j].id == subSectorId) {
          subSectorName = this.sectors[i].subDomains[j].displayName;
          break;
        }
      }
    }
  }
  return subSectorName;
}

getJdnFeatures(corpId) {
  return this.http.get(this.corporateUrl + '/' + corpId + '/jdn/config', { headers: headers}) ;
}
getJDNDetails(corpId) {
return this.http.get(this.corporateUrl + '/' + corpId + '/jdn', { headers: headers}) ;
}
setJDN(corpId, formData) {
  return this.http.post(this.corporateUrl + '/' + corpId + '/jdn/enable', formData, { headers: headers});

}
updateJDN(corpId, formData) {
  return this.http.put(this.corporateUrl + '/' + corpId + '/jdn', formData, { headers: headers});
}
enableJDN (corpId, formData) {
  return this.http.put(this.corporateUrl + '/' + corpId + '/jdn/enable', formData, { headers: headers});
}
disableJDN(corpId) {
  return this.http.put(this.corporateUrl + '/' + corpId + '/jdn/disable',  { headers: headers});
}
getAddons(id) {
  return this.http.get(this.corporateUrl + '/' + id + '/addon', { headers: headers});

}
addAddon(corpId, addonId) {
 return this.http.put(this.corporateUrl + '/' + corpId + '/addon/'  + addonId, { headers: headers});
}
updateLicense(corpId, licenseId): any {
return this.http.put(this.corporateUrl + '/' + corpId + '/license/' + licenseId , { headers: headers});
}
renewLicense(data) {
 return this.http.put(this.corporateLicenseRenewalUrl, data, { headers: headers});
}
deleteAddon(corpId, addonId) {
  return this.http.delete(this.corporateUrl + '/' + corpId + '/addon/'  + addonId, { headers: headers});

}
setJDNForBranches(corpId) {
  return this.http.post(this.corporateUrl + '/' + corpId + '/branch/jdn/enable', { headers: headers});
}

updateBranchLicense(corpId) {
  return this.http.put(this.corporateUrl + '/' + corpId + '/branch/license', {headers: headers});
}
updateBranchAddon(corpId) {
  return this.http.put(this.corporateUrl + '/' + corpId + '/branch/addon', {headers: headers});
}
renewBranchLicense(corpId) {
  return this.http.put(this.corporateUrl + '/' + corpId + '/branch/renewLicense', {headers: headers});
}
revert(corpLicenseId, corpId) {
  return this.http.put(this.revertUrl + '/' + corpLicenseId + '/downgrade' + '/revert' + '/' + corpId, { headers: headers });
}
addAddress(data,id) {
  return this.http.put(this.addressUrl + '/' + 'address/' + id, data,{ headers: headers });
 }
}
